module.exports = __webpack_public_path__ + "static/media/image2.d62d1380.svg";